import { createContext, useContext } from 'react';

type MobileLinesContextType = {
    showOptionDataSharing: boolean;
    setOptionShowDataSharing: (value: boolean) => void;
};

export const MobileLinesContext = createContext({} as MobileLinesContextType);

export const useMobileLinesContext = () => {
    const context = useContext(MobileLinesContext);

    if (!context) throw new Error('useMobileLinesContext must be used within a MobileLinesProvider');

    return context;
};
